const runtimeConfig = window.__CHATVIA_CONFIG__ || {}

const config = {
	apiUrl: runtimeConfig.API_URL || process.env.REACT_APP_API_URL || '',
	cloudinaryPresetName:
		runtimeConfig.CLOUDINARY_PRESET_NAME ||
		process.env.REACT_APP_CLOUDINARY_PRESET_NAME ||
		'',
	cloudinaryName:
		runtimeConfig.CLOUDINARY_NAME || process.env.REACT_APP_CLOUDINARY_NAME || '',
	cloudinaryKey:
		runtimeConfig.CLOUDINARY_KEY || process.env.REACT_APP_CLOUDINARY_KEY || '',
}

export default config
